import React, { useState } from "react";
import SearchBar from "../../components/searchBar";
import "./index.css";
import { ImageUrl, postApiCall, searchhomeapi } from "../../API/baseUrl";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Avatar,
  IconButton,
  ClickAwayListener,
} from "@mui/material";
import { CiSearch } from "react-icons/ci";

const SearchPage = ({ onClose }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState([]);
  const [sortByColumnName, setSortByColumnName] = useState("");

  const handleOnSearchChange = async (e) => {
    setSearch(e.target.value);
    try {
      const { data } = await postApiCall(searchhomeapi, {
        limit: limit,
        offset: offset,
        search: e.target.value,
        column_name: sortByColumnName,
        sort_by: sortBy === "asc" ? "DESC" : "ASC",
      });
      if (data.status) {
        setData(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleListClick = (id, name) => {
    navigate(`/productDetails/${id}/${name}`);
    setSearch("");
    onClose();
  };

  return (
    <ClickAwayListener onClickAway={() => search && onClose()}>
      <Box className="search_container_fluid">
        <SearchBar {...{ handleOnSearchChange, setSearch, search, onClose }} />

        {search && (
          <Paper
            elevation={3}
            sx={{
              p: 2,
              borderRadius: 2,
              backgroundColor: "#fafafa",
              maxHeight: 400,
              overflowY: "auto",
            }}
          >
            {data.map((item) => (
              <Box key={item.id} sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      borderRadius: 1,
                      transition: "0.3s",
                    },
                    p: 1,
                  }}
                  onClick={() => handleListClick(item.id, item?.productName)}
                >
                  <IconButton disableRipple>
                    <CiSearch size={20} />
                  </IconButton>
                  <Avatar
                    src={`${ImageUrl}${item.files || item.file}`}
                    alt={item?.productName}
                    sx={{ width: 40, height: 40 }}
                  />
                  <Typography variant="body1" sx={{ flex: 1 }}>
                    {item?.productName}
                  </Typography>
                </Box>
                <Divider />
              </Box>
            ))}
          </Paper>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default SearchPage;
